<template>
  <div class="d-flex">
    <!-- ALERTS -->
    <v-alert v-if="!isLoading && quoteWasNotFound" type="error" class="mw-300 mb-0 mr-5" text>
      {{ $t('quote.hint.notFound') }}
    </v-alert>

    <v-alert v-if="!isLoading && isQuoteAlreadyPaid" type="success" class="mw-300 mb-0 mr-5" text>
      <h4 class="mt-0">{{ $t('quote.hint.alreadyPaid') }}</h4>
      <span v-if="appointment.type !== 'DUMP'" class="d-block mb-0 mt-1 body-2">
        {{ isRentOut
          ? $t('quote.hint.paymentAcceptedAndPaid')
          : $t('quote.hint.paymentPaidByBalance')
        }}
      </span>
    </v-alert>

    <v-alert v-if="!isLoading && isQuotePending" type="warning"  class="mw-300 mb-0 mr-5" text>
      <h4>{{ $t('quote.hint.awaitingPayment') }}</h4>
      <span class="d-block mb-0 body-2">
        {{ $t('quote.hint.keyWithTenant') }}
      </span>
    </v-alert>
    <!-- /ALERTS -->
  </div>
</template>

<script>
import { rentOutTypes } from '@/components/appointment/formFieldsCreate/appointmentFormDefaults'

export default {
  name: 'AppointmentQuoteAlerts',

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },

    appointment: {
      type: Object,
      required: true,
    },

    quoteWasNotFound: {
      type: Boolean,
      default: false,
    },

    isQuoteAlreadyPaid: {
      type: Boolean,
      default: false,
    },

    isQuotePending: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isRentOut() {
      return rentOutTypes.includes(this.appointment.type)
    }
  },
}
</script>
